module.exports = __webpack_public_path__ + "img/partner_02.35560df4.png";